import "../../assets/css/Header.css";

const Head = () => {
  const storedItem = localStorage.getItem('styli_fileUpload');
  const parsedItem = JSON.parse(storedItem);
  const email = parsedItem.user.email;
  return (
    <div className="group-div">
      <div className="group-child35" />
      <div className="group-parent">
        <div className="group-group">
          <img className="group-icon1" alt="" src="/group@2x.png" />
          <div className="rectangle-parent1">
            <div className="group-child36" />
            <div className="vector-parent">
              <img className="vector-icon2" alt="" src="/smallvector@2x.png" />
              <div className="en">EN</div>
            </div>
          </div>
        </div>
        <div className="trackstylishopcom-parent">
          <div className="trackstylishopcom">{email}</div>
          <img className="ellipse-icon" alt="" src="/ellipse-11@2x.png" />
        </div>
      </div>
    </div>
  );
};

export default Head;
